import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import FloatingButtons from './components/FloatingButtons/FloatingButtons'; // 1. Import et

function App() {
  return (
    <> {/* Fragment kullanıyoruz ki Routes'u sarmalasın */}
      <Routes>
        <Route path='/' element={<HomePage/>}/>
      </Routes>
      <FloatingButtons /> {/* 2. Routes'un dışına, en sona koyuyoruz */}
    </>
  );
}

export default App;